export default "__VITE_ASSET__1f0f0e61__"